import Administration from '@v2/domains/administration/views/Administration.view'
import ClinicsView from '@v2/domains/clinics/views/Clinics.view'
import SingleClinicView from '@v2/domains/clinics/views/SingleClinic.view'
import DataProcessingPage from '@v2/domains/data-process/view/DataProcess'
import CreateEmailTemplateView from '@v2/domains/email-template/views/CreateEmailTemplate/CreateEmailTemplate.view'
import EmailTemplateView from '@v2/domains/email-template/views/EmailTemplate/EmailTemplate.view'
import EmailTemplatesView from '@v2/domains/email-template/views/EmailTemplates/EmailTemplates.view'
import EnrollmentCheckerView from '@v2/domains/enrollment-checker/EnrollmentChecker.view'
import EscalationTableView from '@v2/domains/escalation/views/EscalationTable.view'
import LocationsPage from '@v2/domains/location/views/Locations.view'
import PersonMergingToolView from '@v2/domains/merging-tool/views/PersonMergingTool.view'
import AccountsPage from '@v2/domains/person/views/accounts/AccountsTable.view'
import LeadsPage from '@v2/domains/person/views/leads/LeadsTable.view'
import SearchResultsPage from '@v2/domains/person/views/search/SearchResult.view'
import PoliciesView from '@v2/domains/policy/views/Policies.view'
import ReportsPage from '@v2/domains/report/views/Reports'
import RoleView from '@v2/domains/role/views/Role.view'
import RolesView from '@v2/domains/role/views/Roles.view'
import {
  RouteConfig,
  DEFAULT_ROUTES as default_routes,
} from '@v2/domains/routing/types/routing.types'
import CreateSmsCampaignView from '@v2/domains/smsCampaigns/views/CreateSmsCampaignView/CreateSmsCampaignView'
import TagsView from '@v2/domains/tag/views/Tags.view'
import TasksTableView from '@v2/domains/task/views/TasksTable.view'
import TeamHubLeadView from '@v2/domains/team-lead-hub/views/TeamHubLead.view'
import TicketsPage from '@v2/domains/ticket/views/Tickets.view'
import CreateUserView from '@v2/domains/user/views/CreateUser.view'
import SingleUserView from '@v2/domains/user/views/SingleUser.view'
import UsersAdministrationPage from '@v2/domains/user/views/Users.view'
import { createElement } from 'react'

import SingleAccountPage from 'src/default/pages/Accounts/SingleAccountPage'
import ABCsAdministrationPage from 'src/default/pages/Administration/ABCsAdministration/ABCsAdministrationPage/ABCsAdministrationPage'
import BenefitsAdministrationPage from 'src/default/pages/Administration/BenefitsAdministration/BenefitsAdministrationPage/BenefitsAdministrationPage'
import AdministrationBenefitsCreate from 'src/default/pages/Administration/BenefitsAdministration/MutateBenefitsAdministrationPage'
import MutateBenefitsAdministrationPage from 'src/default/pages/Administration/BenefitsAdministration/MutateBenefitsAdministrationPage/MutateBenefitsAdministrationPage'
import DashboardPage from 'src/default/pages/Dashboard/Dashboard'
import { DataLoaderPage } from 'src/default/pages/DataLoader'
import SingleFormSubmission from 'src/default/pages/Forms/SingleFormSubmission/SingleFormSubmission'
import FormSubmissionsPage from 'src/default/pages/Forms/SubmissionsPage'
import CreateLeadPage from 'src/default/pages/Leads/CreateLeadPage/CreateLeadPage'
import SingleLeadPage from 'src/default/pages/Leads/SingleLeadPage'
import SmsCampaignDetail from 'src/default/pages/Sms/SmsCampaignDetail/SmsCampaignDetail'
import SmsCampaignsPage from 'src/default/pages/Sms/SmsCampaigns'
import AdministrationBenefitsTemplatePreview from 'src/default/templates/AdministrationBenefitsTemplatePreview/AdministrationBenefitsTemplatePreview'

import { DEFAULT_ROUTES_CONFIG } from './route-configs.constants'

export const DEFAULT_ROUTES: Record<string, RouteConfig> = {
  [default_routes.DASHBOARD]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.DASHBOARD],
    element: createElement(DashboardPage),
  },
  [default_routes.LEADS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEADS],
    element: createElement(LeadsPage),
  },
  [default_routes.LEAD_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEAD_DETAIL],
    element: createElement(SingleLeadPage),
  },
  [default_routes.LEAD_TICKET_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEAD_TICKET_DETAIL],
    element: createElement(SingleLeadPage),
  },
  [default_routes.LEAD_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEAD_CREATE],
    element: createElement(CreateLeadPage),
  },
  [default_routes.ACCOUNTS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ACCOUNTS],
    element: createElement(AccountsPage),
  },
  [default_routes.ACCOUNT_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ACCOUNT_DETAIL],
    element: createElement(SingleAccountPage),
  },
  [default_routes.ACCOUNT_TICKET_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ACCOUNT_TICKET_DETAIL],
    element: createElement(SingleAccountPage),
  },
  [default_routes.MERGING_TOOL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.MERGING_TOOL],
    element: createElement(PersonMergingToolView),
  },
  [default_routes.TICKETS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.TICKETS],
    element: createElement(TicketsPage),
  },
  [default_routes.TASKS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.TASKS],
    element: createElement(TasksTableView),
  },
  [default_routes.ESCALATIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ESCALATIONS],
    element: createElement(EscalationTableView),
  },
  [default_routes.ADMINISTRATION]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION],
    element: createElement(Administration),
  },
  [default_routes.ADMINISTRATION_ABCS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_ABCS],
    element: createElement(ABCsAdministrationPage),
  },
  [default_routes.ADMINISTRATION_BENEFITS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_BENEFITS],
    element: createElement(BenefitsAdministrationPage),
  },
  [default_routes.ADMINISTRATION_BENEFITS_PREVIEW]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_BENEFITS_PREVIEW],
    element: createElement(AdministrationBenefitsTemplatePreview),
  },
  [default_routes.ADMINISTRATION_BENEFITS_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_BENEFITS_DETAIL],
    element: createElement(MutateBenefitsAdministrationPage),
  },
  [default_routes.ADMINISTRATION_BENEFITS_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_BENEFITS_CREATE],
    element: createElement(AdministrationBenefitsCreate),
  },
  [default_routes.ADMINISTRATION_POLICIES]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_POLICIES],
    element: createElement(PoliciesView),
  },
  [default_routes.ADMINISTRATION_ROLES]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_ROLES],
    element: createElement(RolesView),
  },
  [default_routes.ADMINISTRATION_ROLES_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_ROLES_DETAIL],
    element: createElement(RoleView),
  },
  [default_routes.ADMINISTRATION_TAGS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_TAGS],
    element: createElement(TagsView),
  },
  [default_routes.ADMINISTRATION_USERS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_USERS],
    element: createElement(UsersAdministrationPage),
  },
  [default_routes.ADMINISTRATION_USERS_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_USERS_CREATE],
    element: createElement(CreateUserView),
  },
  [default_routes.ADMINISTRATION_USERS_DETAILS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_USERS_DETAILS],
    element: createElement(SingleUserView),
  },
  [default_routes.ADMINISTRATION_EMAIL_TEMPLATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_EMAIL_TEMPLATE],
    element: createElement(EmailTemplatesView),
  },
  [default_routes.ADMINISTRATION_EMAIL_TEMPLATE_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.ADMINISTRATION_EMAIL_TEMPLATE_DETAIL
    ],
    element: createElement(EmailTemplateView),
  },
  [default_routes.ADMINISTRATION_EMAIL_TEMPLATE_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.ADMINISTRATION_EMAIL_TEMPLATE_CREATE
    ],
    element: createElement(CreateEmailTemplateView),
  },
  [default_routes.REPORTS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.REPORTS],
    element: createElement(ReportsPage),
  },
  [default_routes.DATA_PROCESSING]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.DATA_PROCESSING],
    element: createElement(DataProcessingPage),
  },
  [default_routes.SEARCH]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SEARCH],
    element: createElement(SearchResultsPage),
  },
  [default_routes.SMS_CAMPAIGNS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SMS_CAMPAIGNS],
    element: createElement(SmsCampaignsPage),
  },
  [default_routes.SMS_CAMPAIGNS_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SMS_CAMPAIGNS_CREATE],
    element: createElement(CreateSmsCampaignView),
  },
  [default_routes.SMS_CAMPAIGNS_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SMS_CAMPAIGNS_DETAIL],
    element: createElement(SmsCampaignDetail),
  },
  [default_routes.FORM_SUBMISSIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.FORM_SUBMISSIONS],
    element: createElement(FormSubmissionsPage),
  },
  [default_routes.FORM_SUBMISSIONS_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.FORM_SUBMISSIONS_DETAIL],
    element: createElement(SingleFormSubmission),
  },
  [default_routes.UPLOAD_FILE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.UPLOAD_FILE],
    element: createElement(DataLoaderPage),
  },
  [default_routes.TEAM_LEAD_HUB]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.TEAM_LEAD_HUB],
    element: createElement(TeamHubLeadView),
  },
  [default_routes.CLINICS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.CLINICS],
    element: createElement(ClinicsView),
  },
  [default_routes.CLINIC_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.CLINIC_DETAIL],
    element: createElement(SingleClinicView),
  },
  [default_routes.LOCATIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LOCATIONS],
    element: createElement(LocationsPage),
  },
  [default_routes.ENROLLMENT_CHECKER]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ENROLLMENT_CHECKER],
    element: createElement(EnrollmentCheckerView),
  },
}
